/* ============================= */
/* VERSION V1.2 - HERO.JSX */
/* Tracking GA4 : appel / WhatsApp / pré-réservation */
/* ============================= */

import React from "react";
import "../styles/Hero.css";
import { trackEvent } from "../utils/analytics";

const Hero = () => {
  return (
    <section className="hero" aria-label="Taxi de la Douce">
      <div className="hero-content">
        <h1 className="hero-brand">TAXI DE LA DOUCE</h1>

        {/* Slogan officiel */}
        <p className="hero-slogan">Votre trajet en toute distinction.</p>

        <div className="hero-buttons">
          <a
            href="tel:+33749424919"
            className="btn btn-primary"
            aria-label="Appeler Taxi de la Douce"
            onClick={() =>
              trackEvent("click_call", {
                event_category: "contact",
                event_label: "hero_call",
                value: 1,
              })
            }
          >
            📞 Appeler
          </a>

          <a
            href="https://wa.me/33749424919"
            className="btn btn-secondary"
            aria-label="WhatsApp Taxi de la Douce"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              trackEvent("click_whatsapp", {
                event_category: "contact",
                event_label: "hero_whatsapp",
                value: 1,
              })
            }
          >
            💬 WhatsApp
          </a>

          <a
            href="#reservation"
            className="btn btn-secondary"
            aria-label="Pré-réservation"
            onClick={() =>
              trackEvent("click_reservation", {
                event_category: "engagement",
                event_label: "hero_reservation",
                value: 1,
              })
            }
          >
            🚖 Pré-réservation
          </a>
        </div>

        {/* SEO discret */}
        <span className="sr-only">
          Taxi Belfort, transferts gare de Belfort, aéroport Bâle-Mulhouse,
          longue distance, réservation 7j/7.
        </span>
      </div>
    </section>
  );
};

export default Hero;





